import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Grid, Snackbar } from '@mui/material';
import { useError } from 'contexts/ErrorContext';

import styles from './styles';
import fullLogo from 'assets/images/logo_full.svg';

const LoginLayout = () => {
    const err = useError();

    const resetError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        // @ts-ignore
        err.DISPATCH({ type: 'RESET_ERROR' });
    };

    return (
        <>
            <Box display='flex' alignItems={'center'} justifyContent={'flex-start'} flexDirection={'column'} sx={styles.background}>
                <Grid container item alignItems='center' justifyContent='space-between' sx={styles.appBar}>
                    <img
                        src={fullLogo}
                        style={styles.fullLogoImg}
                        alt={'Repair Exchange'}
                    />
                </Grid>
                <Grid container item alignItems='center' justifyContent='center' sx={styles.menu} xs={10} sm={8} md={6} lg={5}>
                    {/* https://reactrouter.com/en/main/components/outlet */}
                    {/* the other routes render inside of <Outlet /> */}
                    <Outlet />
                </Grid>
                <Box
                    sx={{
                        width: '100%',
                        height: '100px',
                        position: 'relative',
                    }}
                >
                    {err.state.showSnack && (
                        <Snackbar
                            open={err.state.showSnack}
                            message={err.state.message}
                            autoHideDuration={6000}
                            onClose={resetError}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            sx={{ position: 'absolute' }}
                        >
                        </Snackbar>
                    )}
                </Box>
            </Box>
        </>
    );
};

export default LoginLayout;